import React, { useEffect } from 'react'
import { StyleSheet, View, Image } from 'react-native'

import {
  Title,
  Button,
  Description,
  Space
} from '@sart/components'
import { CompanyIcon, Confirmation as Confirmed } from '@sart/icons'
import { useContent } from '@sart/content'
import { colors, typography } from '@sart/styles'
import client, { useClient } from '@sart/client'

export default function Confirmation(props) {
  const { navigation, route } = props

  //const confirmation = navigation.getParam('confirmation')
  console.log(route.params)
  const confirmation = route.params?.confirmation
  const title = confirmation.title
  const description = confirmation.description
  const status = confirmation.status
  const content = useContent()

  const {
    cache: {
      accounts,
    } = {}
  } = useClient()

  useEffect(() => {
    //refresh accounts on confirmation screen
    client.setCache({ refreshDashboardData: Date.now() })
    // setTimeout(() => client.loadBalancesAndInvoices(accounts[0]), 3000)
  }, [])

  return (
    <View style={styles.container}>
      <View style={styles.widthRestrictions}>
        {title === content.gift.confirm &&
          <Confirmed color={colors.white} />
        }

        {title === content.swap.swapped &&
          <Confirmed color={colors.white} />
        }

        {(status !== 'failed' && title === content.port.confirmationTitle) &&
          <Image
            source={{ uri: 'https://shop.bikermobile.com/assets/green_checkmark.gif' }}
            height={100} width={100} alignSelf={"center"}
          />
        }

        <Space height={48} />

        <Title style={styles.title}>{title}</Title>

        <Space height={24} />

        <Description style={styles.description}>{description}</Description>

        <Space height={48} />

        <Button
          style={styles.button}
          title={content.payment_confirm.action}
          onPress={() => {
            // navigation.popToTop()
            navigation.reset({
              index: 0,
              routes: [
                {
                  name: 'AddOns',
                },
              ],
            });
            // navigation.navigate('AddOns',{},{pop: true})
            navigation.navigate('Dashboard')
          }}
          titleStyle={{ ...typography.extrabold, fontSize: 18 }}
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.darkCharcoal,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.brightOrange,
    ...typography.bold,
    fontSize: 24
  },
  description: {
    textAlign: 'center',
    color: colors.white,
    fontSize: 18
  },
  button: {
    alignSelf: 'stretch',
    backgroundColor: colors.brightOrange
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600
  }
})
